import React from 'react';
import { Button, IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';

const ImageUploadFormGroup = ({ imageUrl, onImageChange, onImageDelete }) => {
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    console.log('file',file)
    if (file) {
      onImageChange(file);
    }
  };

  return (
    <div>
      <input
        accept="image/*"
        style={{ display: 'none' }}
        id="image-upload"
        type="file"
        onChange={handleImageUpload}
      />
      <label htmlFor="image-upload">
        <Button variant="contained" component="span">
          Carica Immagine
        </Button>
      </label>
      {imageUrl && (
        <div style={{ marginTop: '10px', display: 'flex' }}>
          <img src={imageUrl} alt="Immagine" style={{ maxWidth: '100%', marginBottom: '10px', height: '8em' }} />
          <IconButton onClick={onImageDelete}>
            <Delete />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default ImageUploadFormGroup;
